export const InviteAcceptErrorCodes = {
  selfInviteError: 'FulfillmentDelegationSelfInviteAcceptance',
  inviteNotFound: 'FulfillmentDelegationAcceptInvitationNotFound',
  inviteNotPending: 'FulfillmentDelegationAcceptInvitationNotPending',
  registrationFailed: 'FulfillmentDelegationRegistrationFailed',
};
